import i18n from 'i18next';
import styles from '../../sass/components/ModuleTrialCard.module.scss'
import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import {useReducer} from "react";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import { navigateToURL} from '@/Utilities/Util';
require('@/Utilities/TestId');

function reducer(state, action) {
    switch(action.type) {
        case "showCheckoutModal":
            return { ...state, showCheckoutModal: action.payload.showCheckoutModal }
        default:
            return state;
    }
}

export function ModuleTrialCard({module, userIsAdmin, hasCustomSalesForceOffer, salesloftURL, features, useModuleSalesName = false}) {

    const [state, dispatch] = useReducer(reducer, {
        showCheckoutModal: false
    });

    return (
        <div className={styles.trialCard} data-testid={"module_trial_card-"+parseStringToTestId(module.name)}>
            <div className={styles.moduleWrap}>
                <span
                    className={styles.icon}
                    style={{color: module.colors.border}}
                    dangerouslySetInnerHTML={{__html: module.tile}}
                ></span>
                <div data-testid={"module_trial_card-div-"+parseStringToTestId(module.name)}>
                    <h3 data-testid="module_trial_card-label_titlediv" className={styles.name} dangerouslySetInnerHTML={{__html: useModuleSalesName ? module.sales_name ?? module.name : module.name}}></h3>
                    <span data-testid="module_trial_card-label_descriptiondiv" className={styles.description}>{module.description}</span>
                </div>
            </div>
            <div className={styles.trialWrap}>
                {module.trial.days_remaining > 0 && <>
                    <span className={styles.active} data-testid={"module_trial_card-span-days_left"}>
                        {`${module.trial.days_remaining} ${module.trial.days_remaining === 1 ? i18n.t("module-trial-card.left.singular") : i18n.t("module-trial-card.left.plural")}`}
                    </span>
                    <span className="d-flex ">
                        <ButtonSecondary
                            dataTestid="module_trial_card-button-open"
                            className={styles.button}
                            size="sm"
                            onClick={() => window.location.href = module.access_url}
                        >{i18n.t("module-trial-card.open")}</ButtonSecondary>
                        { !hasCustomSalesForceOffer && features['checkout'] && (
                            <ButtonPrimary
                                dataTestid={'module_trial_card-button-subscribe'}
                                className={styles.button}
                                onClick={() => { !salesloftURL ?
                                    dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                                }}
                                size="sm"
                            >{i18n.t("module-trial-card.subscribe")}</ButtonPrimary>
                        )}
                    </span>
                </>
                }
                {module.trial.days_remaining <= 0 && <>
                    <span data-testid={"module_trial_card-span-expired"} className={styles.expired}>{i18n.t("module-trial-card.expired")}</span>
                    {userIsAdmin && features['checkout'] &&
                        <ButtonPrimary
                            dataTestid={'module_trial_expired_card-button-subscribe'}
                            onClick={() => { !salesloftURL ?
                                dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                            }}
                            className={styles.subscribe}>{i18n.t('organization-account.subscribe')}
                        </ButtonPrimary>
                    }
                </>}
            </div>

            { state.showCheckoutModal ? <GeneralPurchaseModal state={state} dispatch={dispatch}/> : null }
        </div>
    )
}
